import { Fragment, memo } from 'react';
import { Row } from 'react-bootstrap';
import LoadMore from '../partials/loadMore';
import ItemWithDeleteIcon from './itemWithDeleteIcon';

const Observation = ({
  perPage,
  totalItem,
  currentPage,
  setCurrentPage,
  allObservations,
  observations,
  handleOnExaminationData,
  handleNoteOfObservation,
  suggestions,
}) => {

  const selectObservation = (item) => {
    if (!observations) return;
  
    const exists = observations.some((observation) => observation.name === item.name);
  
    const updatedObservations = exists
      ? observations.filter((observation) => observation.name !== item.name)
      : [...observations, { name: item.name, side: '', note: '' }];
  
    handleOnExaminationData(updatedObservations, 'observation');
  };

  const selectObservationWithNote = (item) => {
    if (!observations) return;
  
    const exists = observations.some((observation) => observation.name === item.name);
  
    const updatedObservations = exists
      ? observations.map((observation) =>
          observation.name !== item.name
            ? observation
            : { ...observation, side: '', note: item?.note }
        )
      : [...observations, { name: item.name, side: '', note: item?.note }];
  
    handleOnExaminationData(updatedObservations, 'observation');
  };
  

  const observationList = allObservations?.map((item, index) => {
    const isSelected = observations?.some(
      (selectedItem) => selectedItem.name === item.name,
    )
      ? true
      : false;
    return (
      <ItemWithDeleteIcon
        key={index}
        item={item}
        isSelected={isSelected}
        itemClickAction={selectObservation}
        suggestions={suggestions}
        selectItemWithNote={selectObservationWithNote}
      />
    );
  });

  return (
    <Fragment>
      <Row className="complains-area mr-0 ml-0">{observationList}</Row>
      <LoadMore
        currentPage={currentPage}
        totalItem={totalItem}
        perPage={perPage}
        currentPageAction={setCurrentPage}
      />
    </Fragment>
  );
};

export default memo(Observation);
